import { Helmet } from "react-helmet-async";

const SiteTitle = ({ title, isVisibleSuffix = true }) => {
  return (
    <Helmet>
      <title>
        {title} {isVisibleSuffix ? " - مصطفی داودی" : ""}
      </title>
    </Helmet>
  );
};

export default SiteTitle;
